import Vue from 'vue'
import UUID from 'vue-uuid'

Vue.use(UUID)
